import React from "react";
import "./MarqueeCard.css";

const MarqueeCard = ({ marqueeItem }) => {
  return (
    <div className="marquee-card">
      <p>{marqueeItem}</p>
    </div>
  );
};

export default MarqueeCard;
